/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ornate_Sleek_Dachshund_AdoreInputs */

const fr_ornate_sleek_dachshund_adore = /** @type {(inputs: Ornate_Sleek_Dachshund_AdoreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Voir tout`)
};

/**

* @param {Ornate_Sleek_Dachshund_AdoreInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const ornate_sleek_dachshund_adore = /** @type {((inputs?: Ornate_Sleek_Dachshund_AdoreInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ornate_Sleek_Dachshund_AdoreInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_ornate_sleek_dachshund_adore(inputs)
});